import { setCountAction } from "./_common.js";

const main = () => {
    if (document.querySelector('#page-search-station') === null) return;
    setCountAction();

    // bfcache から復元された場合は強制リロードして最新のセッション条件を反映する
    window.addEventListener('pageshow', (event) => {
        if (event.persisted) {
            window.location.reload();
        }
    });
}

export default main;
